// extracted by mini-css-extract-plugin
export default {"noBackground":"Aja-z","qnaContainer":"Bja-z","qna":"Cja-z","question":"Dja-z","modal":"Eja-z"};